module.exports = __webpack_public_path__ + "img/bigscoots-logo-mascot-white.74a77105.svg";